import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ApiTokenService } from '@core/services/api-token.service';

/**
 * Global HTTP error interceptor.
 *
 * - 401 Unauthorized → clears token and redirects to /login
 * - 403 Forbidden    → redirects to /dashboard (or a "no access" page)
 * - 5xx Server error → logs and re-throws so callers can react
 *
 * Individual services/components can still add their own `catchError` on top.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const tokenService = inject(ApiTokenService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 401:
          tokenService.clearToken();
          router.navigate(['/login']);
          break;
        case 403:
          router.navigate(['/dashboard']);
          break;
      }

      return throwError(() => error);
    }),
  );
};
